module.exports = __webpack_public_path__ + "media/images/childcare/main_image2@3x-5e25defba35673fc264c428fb6eec871.jpg";